import httpRequest from "../../../infrastructure/httphelper";

import sharedGlobals from "../../../sharedglobals";


class SecMasterService {

    constructor() { }

    getInsuredInformationMasters(productType) {
        let url =
            sharedGlobals.appUrls.insSharedApiUrl + "api/InsShared/GetInsuredInformationMasters";
        let params = {
            productType: productType
        }
        return httpRequest({
            url: url,
            method: "POST",
            data: productType,
            headers: {
                "Content-Type": "application/json"
            }
        });
    }
    getSecurityMasters() {
        let url =
            sharedGlobals.appUrls.securityApiUrl + "api/Security/GetSecurityMasters";

        return httpRequest({
            url: url,
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            }
        });
    }
    getUserSearchResults(searchParams) {
        let url = sharedGlobals.appUrls.securityApiUrl + "api/Security/GetUserSearchResults";
        return httpRequest({
            url: url,
            method: "POST",
            dataType: 'json',
            data: searchParams,

        });
    }

    getUserMaster(userId) {
        let url = sharedGlobals.appUrls.securityApiUrl + "api/Security/GetUserInformation";
        return httpRequest({
            url: url,
            method: "POST",
            dataType: 'json',
            data: userId

        });
    }


    /*saveUserMaster(saveUserMasterInfo) {
        let url =
            sharedGlobals.appUrls.miCoreApiUrl + "api/Security/SaveUserMaster";
        return httpRequest({
            url: url,
            method: "POST",
            data: saveUserMaster
        });
    } */

    savePasswordProfile(savePasswordProfileInfo) {
        let url =
            sharedGlobals.appUrls.securityApiUrl + "api/Security/SavePasswordProfile";
        return httpRequest({
            url: url,
            method: "POST",
            data: savePasswordProfileInfo
        });
    }

    getAllPasswordProfiles(searchParams) {
        let url =
            sharedGlobals.appUrls.securityApiUrl + "api/Security/GetAllPasswordProfiles";
        return httpRequest({
            url: url,
            method: "POST",
            data: searchParams
        });
    }

    getAllPasswordProfilesByProfileId(passwordProfileId) {

        let url =
            sharedGlobals.appUrls.securityApiUrl + "api/Security/GetAllPasswordProfilesByProfileId";
        return httpRequest({
            url: url,
            method: "POST",
            params: passwordProfileId
        });
    }

    /* updatePasswordProfile(savedPasswordProfileInfo){
       let url =
       sharedGlobals.appUrls.securityApiUrl + "api/Security/UpdatePasswordProfile";
     return httpRequest({
       url: url,
       method: "POST",
       data: savedPasswordProfileInfo
     });
     }*/

    getAllMenus() {
        let url =
            sharedGlobals.appUrls.securityApiUrl + "api/Security/GetAllMenus";
        return httpRequest({
            url: url,
            method: "POST",
        });
    }

    getAllGroups() {
        let url =
            sharedGlobals.appUrls.securityApiUrl + "api/Security/GetAllGroups";
        return httpRequest({
            url: url,
            method: "POST",
        });
    }

    getAllGroupMenus() {
        let url =
            sharedGlobals.appUrls.securityApiUrl + "api/Security/GetAllGroupMenus";
        return httpRequest({
            url: url,
            method: "POST",
        });
    }

    getAllModules() {
        let url =
            sharedGlobals.appUrls.securityApiUrl + "api/Security/GetAllModules";
        return httpRequest({
            url: url,
            method: "POST",
        });
    }

    getAllUserBranches() {
        let url =
            sharedGlobals.appUrls.securityApiUrl + "api/Security/GetAllUserBranches";
        return httpRequest({
            url: url,
            method: "POST",
        });
    }
    saveUserMasterInfo(saveUserMaster) {
        let url =
            sharedGlobals.appUrls.securityApiUrl + "api/Security/SaveUserMaster";
        return httpRequest({
            url: url,
            method: "POST",
            data: saveUserMaster
        });
    }
    saveUserApplicableBranches(saveUserBranches) {
        let url =
            sharedGlobals.appUrls.securityApiUrl + "api/Security/SaveUserApplicableBranches";
        return httpRequest({
            url: url,
            method: "POST",
            data: saveUserBranches
        });
    }
    saveBrokerApplicableBranches(saveUserBranches) {
        let url =
            sharedGlobals.appUrls.securityApiUrl + "api/Security/SaveBrokerApplicableBranches";
        return httpRequest({
            url: url,
            method: "POST",
            data: saveUserBranches
        });
    }

    getUserApplicableBranches(userId) {
        let url = sharedGlobals.appUrls.securityApiUrl + "api/Security/GetUserApplicableBranches";
        return httpRequest({
            url: url,
            method: "POST",
            dataType: 'json',
            data: userId,

        });
    }


    getUserGroupSearchResults(searchParams) {
        let url = sharedGlobals.appUrls.securityApiUrl + "api/Security/GetUserGroupSearchResults";
        return httpRequest({
            url: url,
            method: "POST",
            dataType: 'json',
            data: searchParams,

        });
    }


    getGroupInfo(groupId) {
        let url = sharedGlobals.appUrls.securityApiUrl + "api/Security/GetGroupInformation";
        return httpRequest({
            url: url,
            method: "POST",
            dataType: 'json',
            data: groupId

        });
    }
    saveUserGroupInfo(saveGroup) {
        let url =
            sharedGlobals.appUrls.securityApiUrl + "api/Security/SaveGroupInformation";
        return httpRequest({
            url: url,
            method: "POST",
            data: saveGroup
        });
    }

    getSystemMenus(groupId) {
        let url =
            sharedGlobals.appUrls.securityApiUrl + "api/Security/GetSystemMenus";
        return httpRequest({
            url: url,
            method: "POST",
            data: groupId
        });
    }
    getUserGroups(userId) {
        let url = sharedGlobals.appUrls.securityApiUrl + "api/Security/GetUserGroups";
        return httpRequest({
            url: url,
            method: "POST",
            dataType: 'json',
            data: userId,

        });
    }

    saveUserGroups(saveUserGroups) {
        let url =
            sharedGlobals.appUrls.securityApiUrl + "api/Security/SaveUserGroups";
        return httpRequest({
            url: url,
            method: "POST",
            data: saveUserGroups
        });
    }

    updateUserActiveStatus(userId) {
        let url =
            sharedGlobals.appUrls.securityApiUrl + "api/Security/UpdateUserActiveStatus";
        let para = {
            userId: userId

        }
        return httpRequest({
            url: url,
            method: "POST",
            params: para
        });
    }
    unlockUser(userId) {
        let url =
            sharedGlobals.appUrls.securityApiUrl + "api/Security/UnlockUser";
        let para = {
            userId: userId
        }
        return httpRequest({
            url: url,
            method: "POST",
            params: para
        });
    }
    sendForgotPassword(email,userName) {
        let url =
            sharedGlobals.appUrls.securityApiUrl + "api/Security/SendForgotPassword";
        let para = {
            userEmail: email,
            loginUserName: userName
        }
        return httpRequest({
            url: url,
            method: "POST",
            params: para
        });
    }

    saveAssignGroupMenus(saveAssignGroupMenus) {
        let url =
            sharedGlobals.appUrls.securityApiUrl + "api/Security/SaveGroupMenusByGroupId";
        return httpRequest({
            url: url,
            method: "POST",
            data: saveAssignGroupMenus
        });
    }

    getSystemReports(groupId) {
        let url =
            sharedGlobals.appUrls.reportManagerApiUrl + "api/ReportEngineService/GetSystemReportsByGroupId";
        return httpRequest({
            url: url,
            method: "POST",
            data: groupId
        });
    }


    saveAssignGroupReports(saveAssignGroupReports) {
        let url =
            sharedGlobals.appUrls.reportManagerApiUrl + "api/ReportEngineService/SaveGroupReportsByGroupId";
        return httpRequest({
            url: url,
            method: "POST",
            data: saveAssignGroupReports
        });
    }


    copyUser(saveUserMaster) {
        let url =
            sharedGlobals.appUrls.securityApiUrl + "api/Security/CopyUser";
        return httpRequest({
            url: url,
            method: "POST",
            data: saveUserMaster
        });
    }
}

let instance = new SecMasterService();
export default instance;